<template>
  <div style="background-color: #FFFFFFB2; height: 100vh;">
    <v-container fluid fill-height style="background-color: #FFFFFFB2;">
      <v-row no-gutters align="center" justify="center">
        <v-col
          cols="12"
          md="7"
          class="d-none d-md-flex justify-start align-center"
        >
          <img
            :src="require('@/assets/logo/Logo.png')"
            class="img-fluid"
            style="max-height: 100vh; max-width: 100%; object-fit: contain;" />
        </v-col>
        <v-col
          cols="12"
          md="5"
          class="px-6"
        >
          <v-card
            flat
            color="#FFFFFFB2"
            class="pa-6"
          >
            <div class="d-flex justify-center mb-4 d-md-none">
              <img
                :src="require('@/assets/logo/logo_small.jpeg')"
                class="img-fluid"
                style="max-height: 100%; max-width: 200px; object-fit: contain;" />
            </div>
            <v-card-text
              class="pa-0">
              <div
                class="mb-6">
                <div
                  class="title font-weight-bold black--text mb-2">
                  Masuk Admin
                </div>
              </div>
  
              <ValidationObserver 
                ref="observer">
                <v-form class="text-left mb-6">
                  <div class="fs-16 label-input">
                    Email
                  </div>
                  <ValidationProvider 
                    name="Email" 
                    rules="required" 
                    v-slot="{ errors }">
                    <v-text-field
                      v-on:keyup.enter="save"
                      class="no_box"
                      solo
                      :color="set_color"
                      placeholder="Email"
  
                      vv-uppercase
  
                      v-model="form.username"
                      :error-messages="errors"
                      required>
                    </v-text-field>
                  </ValidationProvider>
  
                  <div class="fs-16 label-input">
                    Password
                  </div>
                  <ValidationProvider 
                    name="password" 
                    rules="required|min:5|max:20" 
                    v-slot="{ errors }">
                    <v-text-field
                      v-on:keyup.enter="save"
                      class="no_box"
                      solo
                      :color="set_color"
                      placeholder="Password"
                      :type="show ? 'text' : 'password'"
                      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show = !show"
                      :counter="20"
  
                      vv-uppercase
                      
                      v-model="form.password"
                      :error-messages="errors"
                      required>
                    </v-text-field>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>
  
              <div 
                class="text-center mb-6">
                <div v-if="message.error.length > 0"
                  class="text-center my-4">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
  
                <v-btn
                  v-on:keyup.enter="save"
                  :disabled="process.form"
                  :loading="process.form"
                  @click="save"
                  block
                  color="#1814F3"
                  width="170"
                  height="50"
                  elevation="0"
                  class="title font-weight-bold white--text text-capitalize border-radius">
                  Masuk
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>


<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        show: false,
        form: {
          username: '',
          password: '',
          device: 'web'
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      }
    },
    mounted () {
      
    },
    methods: {

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true

          await post('admin/auth/login', {
            data: this.form
          })
          .then(response => {
            let res = response.data

            if (res.status === 200) {
              console.log(res.results.data)
              let user = res.results.data,
                  menu_arr = res.results.data.category_user_menu_arr.length < 1 ? [] : JSON.parse(res.results.data.category_user_menu_arr),
                  menu_default = [
                    {
                      id: 122,
                      title: 'Dashboard',
                      icon: require('@/assets/icon/dashboard.png'),
                      icon_color: require('@/assets/icon/dashboard.png'),
                      link: '/dashboard',
                      active: false,
                      sub_menu: [],
                    },
        { 
                      id: 1,
                      title: 'User',
                      icon: require('@/assets/icon/profile.png'),
                      icon_color: require('@/assets/icon/profile-color.png'),
                      link: '/user',
                      active: false,
                      sub_menu: [
                        {
                          id: 2,
                          title: 'Staff',
                          link: '/user/staff',
                          icon: require('@/assets/icon/profile.png'),
                          icon_color: require('@/assets/icon/profile-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 3,
                          title: 'Supplier',
                          link: '/user/supplier',
                          icon: require('@/assets/icon/profile.png'),
                          icon_color: require('@/assets/icon/profile-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 4,
                          title: 'Kategori Staff',
                          link: '/user/category',
                          icon: require('@/assets/icon/profile.png'),
                          icon_color: require('@/assets/icon/profile-color.png'),
                          active: false,
                          sub_menu: [],
                        }
                      ],
                    },
                    {
                      id: 10,
                      title: 'Sales',
                      icon: require('@/assets/icon/sales-manager.png'),
                      icon_color: require('@/assets/icon/sales-manager-color.png'),
                      link: '/sales',
                      active: false,
                      sub_menu: [
                        {
                          id: 11,
                          title: 'sales',
                          link: '/sales/staff',
                          icon: require('@/assets/icon/sales-manager.png'),
                          icon_color: require('@/assets/icon/sales-manager-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 12,
                          title: 'Kode Sales (Area Sales)',
                          link: '/sales/code',
                          icon: require('@/assets/icon/sales-manager.png'),
                          icon_color: require('@/assets/icon/sales-manager-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        // {
                        //   id: 13,
                        //   title: 'Target Sales',
                        //   link: '/sales/target',
                        //   icon: require('@/assets/icon/salesGrey.png'),
                        //   icon_color: require('@/assets/icon/salesBlack.png'),
                        //   active: false,
                        //   sub_menu: [],
                        // }
                      ],
                    },
                    {
                      id: 6,
                      title: 'Customer',
                      icon: require('@/assets/icon/target.png'),
                      icon_color: require('@/assets/icon/target-color.png'),
                      link: '/customer/data',
                      active: false,
                      sub_menu: [
                      {
                          id: 7,
                          title: 'Customer Saya',
                          link: '/customer/data',
                          icon: require('@/assets/icon/target.png'),
                          icon_color: require('@/assets/icon/target-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 59,
                          title: 'Pengajuan Customer',
                          link: '/customer/proses',
                          icon: require('@/assets/icon/target.png'),
                          icon_color: require('@/assets/icon/target-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        // {
                        //   id: 60,
                        //   title: 'Proses Pengajuan',
                        //   link: '/customer/acc',
                        //   icon: require('@/assets/icon/target.png'),
                        //   icon_color: require('@/assets/icon/target-color.png'),
                        //   active: false,
                        //   sub_menu: [],
                        // },
                        {
                          id: 61,
                          title: 'Histori Rejected',
                          link: '/customer/reject',
                          icon: require('@/assets/icon/target.png'),
                          icon_color: require('@/assets/icon/target-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 81,
                          title: 'Customer Blacklist',
                          link: '/customer/blacklist',
                          icon: require('@/assets/icon/target.png'),
                          icon_color: require('@/assets/icon/target-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        // {
                        //   id: 8,
                        //   title: 'Toko',
                        //   link: '/customer/toko',
                        //   active: false,
                        //   sub_menu: [],
                        // },
                        {
                          id: 8,
                          title: 'Perubahan Plafon',
                          link: '/customer/plafon',
                          icon: require('@/assets/icon/target.png'),
                          icon_color: require('@/assets/icon/target-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 9,
                          title: 'Perubahan Customer',
                          link: '/customer/perubahan',
                          icon: require('@/assets/icon/target.png'),
                          icon_color: require('@/assets/icon/target-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 84,
                          title: 'Customer Mapping',
                          link: '/customer/mapping',
                          icon: require('@/assets/icon/target.png'),
                          icon_color: require('@/assets/icon/target-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                      ],
                    },
                    {
                      id: 85,
                      title: 'Live Tracking',
                      icon: require('@/assets/icon/shipment-tracking.png'),
                      icon_color: require('@/assets/icon/shipment-tracking-color.png'),
                      link: '/tracking',
                      active: false,
                      sub_menu: [
                        {
                          id: 86,
                          title: 'live Sales',
                          link: '/tracking/sales',
                          icon: require('@/assets/icon/shipment-tracking.png'),
                          icon_color: require('@/assets/icon/shipment-tracking-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 87,
                          title: '⁠Live Driver',
                          link: '/tracking/driver',
                          icon: require('@/assets/icon/shipment-tracking.png'),
                          icon_color: require('@/assets/icon/shipment-tracking-color.png'),
                          active: false,
                          sub_menu: [],
                        }
                      ],
                    },
                    {
                      id: 14,
                      title: 'Produk',
                      icon: require('@/assets/icon/dairy-products.png'),
                      icon_color: require('@/assets/icon/dairy-products-color.png'),
                      link: '/product',
                      active: false,
                      sub_menu: [
                        {
                          id: 15,
                          title: 'Data Produk',
                          link: '/product/data',
                          icon: require('@/assets/icon/dairy-products.png'),
                          icon_color: require('@/assets/icon/dairy-products-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 16,
                          title: 'Varian Produk',
                          link: '/product/varian',
                          icon: require('@/assets/icon/dairy-products.png'),
                          icon_color: require('@/assets/icon/dairy-products-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 17,
                          title: 'Kategori Produk',
                          link: '/product/category_product',
                          icon: require('@/assets/icon/dairy-products.png'),
                          icon_color: require('@/assets/icon/dairy-products-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 18,
                          title: 'Group Produk',
                          link: '/product/group',
                          icon: require('@/assets/icon/dairy-products.png'),
                          icon_color: require('@/assets/icon/dairy-products-color.png'),
                          active: false,
                          sub_menu: [],
                        }
                      ],
                    },
                  {
                    id: 41,
                    title: 'Stok',
                    icon: require('@/assets/icon/in-stock.png'),
                    icon_color: require('@/assets/icon/in-stock-color.png'),
                    link: '/stok',
                    active: false,
                    sub_menu: [
                      {
                        id: 42,
                        title: 'Stok',
                        link: '/stok/data',
                        icon: require('@/assets/icon/in-stock.png'),
                        icon_color: require('@/assets/icon/in-stock-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      // {
                      //   id: 43,
                      //   title: 'Stok In Order',
                      //   link: '/stok/in-order',
                      //   icon: require('@/assets/icon/in-stock.png'),
                      //   icon_color: require('@/assets/icon/in-stock-color.png'),
                      //   active: false,
                      //   sub_menu: [],
                      // },
                      {
                        id: 90,
                        title: 'Penyesuaian Stok',
                        link: '/stok/penyesuaian-stock',
                        icon: require('@/assets/icon/in-stock.png'),
                        icon_color: require('@/assets/icon/in-stock-color.png'),
                        active: false,
                        sub_menu: [],
                      }
                    ],
                  },
                    {
                      id: 22,
                      title: 'Kelola Visit',
                      icon: require('@/assets/icon/visitor.png'),
                      icon_color: require('@/assets/icon/visitor-color.png'),
                      link: '/visit',
                      active: false,
                      sub_menu: [
                        // {
                        //   id: 23,
                        //   title: 'Laporan Visit',
                        //   link: '/visit/laporan',
                        //   icon: require('@/assets/icon/visitor.png'),
                        //   icon_color: require('@/assets/icon/visitor-color.png'),
                        //   active: false,
                        //   sub_menu: [],
                        // },
                        {
                          id: 78,
                          title: 'Laporan Visit',
                          link: '/visit/laporan',
                          icon: require('@/assets/icon/visitor.png'),
                          icon_color: require('@/assets/icon/visitor-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 24,
                          title: 'Buat Jadwal Visit',
                          link: '/visit/jadwal',
                          icon: require('@/assets/icon/visitor.png'),
                          icon_color: require('@/assets/icon/visitor-color.png'),
                          active: false,
                          sub_menu: [],
                        },

                        {
                          id: 83,
                          title: 'Pergantian Jadwal',
                          link: '/visit/jadwal-change',
                          icon: require('@/assets/icon/visitor.png'),
                          icon_color: require('@/assets/icon/visitor-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                      ],
                    },
                    {
                      id: 111,
                      title: 'Laporan Visit Driver',
                      icon: require('@/assets/icon/route.png'),
                      icon_color: require('@/assets/icon/route.png'),
                      link: '/laporan-visit-driver',
                      active: false,
                      sub_menu: [],
                    },
                    {
                      id: 25,
                      title: 'Presensi',
                      icon: require('@/assets/icon/absent.png'),
                      icon_color: require('@/assets/icon/absent-color.png'),
                      link: '/presensi',
                      active: false,
                      sub_menu: [
                        {
                          id: 26,
                          title: 'Laporan Presensi',
                          link: '/presensi/data',
                          icon: require('@/assets/icon/absent.png'),
                          icon_color: require('@/assets/icon/absent-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 27,
                          title: 'Laporan Ijin',
                          link: '/presensi/ijin',
                          icon: require('@/assets/icon/absent.png'),
                          icon_color: require('@/assets/icon/absent-color.png'),
                          active: false,
                          sub_menu: [],
                        }
                      ],
                    },
                    {
                    id: 28,
                    title: 'Pembelian',
                    icon: require('@/assets/icon/cash-on-delivery.png'),
                    icon_color: require('@/assets/icon/cash-on-delivery-color.png'),
                    link: '/pengajuan',
                    active: false,
                    sub_menu: [
                      {
                        id: 29,
                        title: 'Permintaan Stok',
                        link: '/pengajuan/pembelian-warehouse',
                        icon: require('@/assets/icon/cash-on-delivery.png'),
                        icon_color: require('@/assets/icon/cash-on-delivery-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      // {
                      //   id: 64,
                      //   title: 'Permintaan Barang',
                      //   link: '/pengajuan/permintaan-barang',
                      //   icon: require('@/assets/icon/cash-on-delivery.png'),
                      //   icon_color: require('@/assets/icon/cash-on-delivery-color.png'),
                      //   active: false,
                      //   sub_menu: [],
                      // },
                      {
                        id: 30,
                        title: 'Permintaan GM',
                        link: '/pengajuan/pembelian-general-manager',
                        icon: require('@/assets/icon/cash-on-delivery.png'),
                        icon_color: require('@/assets/icon/cash-on-delivery-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 31,
                        title: 'Penerimaan Stok',
                        link: '/pengajuan/penerimaan/data',
                        icon: require('@/assets/icon/cash-on-delivery.png'),
                        icon_color: require('@/assets/icon/cash-on-delivery-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 32,
                        title: 'QC Barang',
                        link: '/pengajuan/qc',
                        icon: require('@/assets/icon/cash-on-delivery.png'),
                        icon_color: require('@/assets/icon/cash-on-delivery-color.png'),
                        active: false,
                        sub_menu: [],
                      }
                    ],
                  },
                  {
                    id: 44,
                    title: 'Order',
                    icon: require('@/assets/icon/order.png'),
                    icon_color: require('@/assets/icon/order-color.png'),
                    link: '/approval',
                    active: false,
                    sub_menu: [
                    {
                        id: 45,
                        title: 'Approval Order',
                        link: '/approval/order',
                        icon: require('@/assets/icon/order.png'),
                        icon_color: require('@/assets/icon/order-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                      id: 46,
                      title: 'Approval Order Warehouse',
                      link: '/approval/order-warehouse',
                      icon: require('@/assets/icon/order.png'),
                      icon_color: require('@/assets/icon/order-color.png'),
                      active: false,
                      sub_menu: [],
                      },
                      {
                        id: 88,
                        title: 'Tracking Order',
                        link: '/approval/order-tracking',
                        icon: require('@/assets/icon/order.png'),
                        icon_color: require('@/assets/icon/order-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 110,
                        title: 'Audit Order',
                        link: '/approval/order-audit',
                        icon: require('@/assets/icon/order.png'),
                        icon_color: require('@/assets/icon/order-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                    ],
                  },

                  // {
                  //   id: 65,
                  //   title: 'Pengajuan Barang',
                  //   icon: require('@/assets/icon/cabangGrey.png'),
                  //   icon_color: require('@/assets/icon/cabangBlack.png'),
                  //   link: '/pengajuan-barang',
                  //   active: false,
                  //   sub_menu: [
                  //   {
                  //       id: 66,
                  //       title: 'Data Pengajuan',
                  //       link: '/pengajuan-barang/data',
                  //       icon: require('@/assets/icon/cabangGrey.png'),
                  //       icon_color: require('@/assets/icon/cabangBlack.png'),
                  //       active: false,
                  //       sub_menu: [],
                  //     },
                  //   {
                  //       id: 67,
                  //       title: 'Approval Atasan',
                  //       link: '/pengajuan-barang/approval-atasan',
                  //       icon: require('@/assets/icon/cabangGrey.png'),
                  //       icon_color: require('@/assets/icon/cabangBlack.png'),
                  //       active: false,
                  //       sub_menu: [],
                  //     },
                  //     {
                  //       id: 68,
                  //       title: 'Approval General Manager',
                  //       link: '/pengajuan-barang/approval-general-manager',
                  //       icon: require('@/assets/icon/cabangGrey.png'),
                  //       icon_color: require('@/assets/icon/cabangBlack.png'),
                  //       active: false,
                  //       sub_menu: [],
                  //     },
                  //     {
                  //       id: 69,
                  //       title: 'Penerimaan Barang',
                  //       link: '/pengajuan-barang/approval-gudang',
                  //       icon: require('@/assets/icon/cabangGrey.png'),
                  //       icon_color: require('@/assets/icon/cabangBlack.png'),
                  //       active: false,
                  //       sub_menu: [],
                  //     },
                  //     {
                  //       id: 73,
                  //       title: 'Update harga & Pilih Supplier',
                  //       link: '/pengajuan-barang/update-harga-supplier',
                  //       icon: require('@/assets/icon/cabangGrey.png'),
                  //       icon_color: require('@/assets/icon/cabangBlack.png'),
                  //       active: false,
                  //       sub_menu: [],
                  //     }
                  //   ],
                  // },

                  // {
                  //   id: 70,
                  //   title: 'Pembayaran Barang',
                  //   icon: require('@/assets/icon/productGrey.png'),
                  //   icon_color: require('@/assets/icon/productBlack.png'),
                  //   link: '/pembayaran-barang',
                  //   active: false,
                  //   sub_menu: [
                  //     {
                  //       id: 71,
                  //       title: 'Kasir',
                  //       link: '/pembayaran-barang/kasir',
                  //       icon: require('@/assets/icon/userGrey.png'),
                  //       icon_color: require('@/assets/icon/userBlack.png'),
                  //       active: false,
                  //       sub_menu: [],
                  //     },
                  //     {
                  //       id: 72,
                  //       title: 'Akunting',
                  //       link: '/pembayaran-barang/akunting',
                  //       icon: require('@/assets/icon/userGrey.png'),
                  //       icon_color: require('@/assets/icon/userBlack.png'),
                  //       active: false,
                  //       sub_menu: [],
                  //     },
                  //     {
                  //       id: 74,
                  //       title: 'Approval Finance Manager',
                  //       link: '/pembayaran-barang/manager-keuangan',
                  //       icon: require('@/assets/icon/userGrey.png'),
                  //       icon_color: require('@/assets/icon/userBlack.png'),
                  //       active: false,
                  //       sub_menu: [],
                  //     },
                  //     {
                  //       id: 75,
                  //       title: 'Approval General Manager',
                  //       link: '/pembayaran-barang/general-manager',
                  //       icon: require('@/assets/icon/userGrey.png'),
                  //       icon_color: require('@/assets/icon/userBlack.png'),
                  //       active: false,
                  //       sub_menu: [],
                  //     },
                  //     {
                  //       id: 76,
                  //       title: 'Print Kasir',
                  //       link: '/pembayaran-barang/print-kasir',
                  //       icon: require('@/assets/icon/userGrey.png'),
                  //       icon_color: require('@/assets/icon/userBlack.png'),
                  //       active: false,
                  //       sub_menu: [],
                  //     }
                  //   ]
                  // },

                  {
                    id: 48,
                    title: 'Pengiriman ',
                    icon: require('@/assets/icon/fast-delivery.png'),
                    icon_color: require('@/assets/icon/fast-delivery-color.png'),
                    link: '/delivery',
                    active: false,
                    sub_menu: [
                    {
                        id: 49,
                        title: 'Buat BPB',
                        link: '/delivery/bpb',
                        icon: require('@/assets/icon/fast-delivery.png'),
                        icon_color: require('@/assets/icon/fast-delivery-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 50,
                        title: 'Buat Surat Jalan',
                        link: '/delivery/surat-jalan',
                        icon: require('@/assets/icon/fast-delivery.png'),
                        icon_color: require('@/assets/icon/fast-delivery-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 77,
                        title: 'Proses Muat',
                        link: '/delivery/proses-muat',
                        icon: require('@/assets/icon/fast-delivery.png'),
                        icon_color: require('@/assets/icon/fast-delivery-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 51,
                        title: 'Konfirmasi Pengiriman',
                        icon: require('@/assets/icon/fast-delivery.png'),
                        icon_color: require('@/assets/icon/fast-delivery-color.png'),
                        link: '/konfirmasi-pengirirman',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 91,
                        title: 'Reschedule BPB',
                        icon: require('@/assets/icon/fast-delivery.png'),
                        icon_color: require('@/assets/icon/fast-delivery-color.png'),
                        link: '/delivery/reschedule',
                        active: false,
                        sub_menu: [],
                      },

                      {
                        id: 58,
                        title: 'Retur',
                        icon: require('@/assets/icon/fast-delivery.png'),
                        icon_color: require('@/assets/icon/fast-delivery-color.png'),
                        link: '/retur',
                        active: false,
                        sub_menu: [], 
                      },
                    ],
                  },


                  {
                    id: 52,
                    title: 'Promo',
                    icon: require('@/assets/icon/promo.png'),
                    icon_color: require('@/assets/icon/promo-color.png'),
                    link: '/promo',
                    active: false,
                    sub_menu: [
                    {
                        id: 53,
                        title: 'Data Promo',
                        link: '/promo/data',
                        icon: require('@/assets/icon/promo.png'),
                        icon_color: require('@/assets/icon/promo-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 54,
                        title: 'Banner',
                        link: '/promo/banner',
                        icon: require('@/assets/icon/promo.png'),
                        icon_color: require('@/assets/icon/promo-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 100,
                        title: 'Strata Harga',
                        icon: require('@/assets/icon/promo.png'),
                        icon_color: require('@/assets/icon/promo-color.png'),
                        link: '/promo/strata-harga',
                        active: false,
                        sub_menu: [],
                      },
                    ],
                  },
                  {
                    id: 33,
                    title: 'Finance',
                    icon: require('@/assets/icon/report.png'),
                    icon_color: require('@/assets/icon/report-color.png'),
                    link: '/finance',
                    active: false,
                    sub_menu: [
                    {
                        id: 34,
                        title: 'Data Penerimaan Stok',
                        link: '/finance/penerimaan/data',
                        icon: require('@/assets/icon/report.png'),
                        icon_color: require('@/assets/icon/report-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 35,
                        title: 'Close PO',
                        link: '/finance/po/data',
                        icon: require('@/assets/icon/report.png'),
                        icon_color: require('@/assets/icon/report-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      // {
                      //   id: 36,
                      //   title: 'Bank',
                      //   link: '/finance/bank',
                      //   icon: require('@/assets/icon/report.png'),
                      //   icon_color: require('@/assets/icon/report-color.png'),
                      //   active: false,
                      //   sub_menu: [],
                      // },
                      {
                        id: 36,
                        title: 'Invoice Supplier',
                        link: '/finance/invoice-supplier',
                        icon: require('@/assets/icon/report.png'),
                        icon_color: require('@/assets/icon/report-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 37,
                        title: 'Invoice Customer',
                        link: '/finance/invoice',
                        icon: require('@/assets/icon/report.png'),
                        icon_color: require('@/assets/icon/report-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 82,
                        title: 'Laporan Piutang',
                        link: '/finance/laporan-faktur',
                        icon: require('@/assets/icon/report.png'),
                        icon_color: require('@/assets/icon/report-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      // {
                      //   id: 62,
                      //   title: 'Approval Permintaan Barang',
                      //   link: '/finance/pengajuan',
                      //   icon: require('@/assets/icon/productGrey.png'),
                      //   icon_color: require('@/assets/icon/productBlack.png'),
                      //   active: false,
                      //   sub_menu: [],
                      // }
                    ],
                  },
                  {
                    id: 38,
                    title: 'Kasir',
                    icon: require('@/assets/icon/cashier.png'),
                    icon_color: require('@/assets/icon/cashier-color.png'),
                    link: '/kasir',
                    active: false,
                    sub_menu: [
                      {
                        id: 39,
                        title: 'Kasir Customer',
                        link: '/kasir/customer',
                        icon: require('@/assets/icon/cashier.png'),
                        icon_color: require('@/assets/icon/cashier-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 40,
                        title: 'Kasir Supplier',
                        link: '/kasir/supplier',
                        icon: require('@/assets/icon/cashier.png'),
                        icon_color: require('@/assets/icon/cashier-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      // {
                      //   id: 63,
                      //   title: 'Pembukuan Permintaan Barang',
                      //   link: '/kasir/pembukuan',
                      //   icon: require('@/assets/icon/productGrey.png'),
                      //   icon_color: require('@/assets/icon/productBlack.png'),
                      //   active: false,
                      //   sub_menu: [],
                      // }
                    ],
                  },

                  {
                    id: 92,
                    title: 'Tanya Laporan AI',
                    icon: require('@/assets/icon/ai.png'),
                    icon_color: require('@/assets/icon/ai.png'),
                    link: '/laporan-ai',
                    active: false,
                    sub_menu: [],
                  },


                  {
                    id: 80,
                    title: 'WA Gateway',
                    icon: require('@/assets/icon/whatsapp.png'),
                    icon_color: require('@/assets/icon/whatsapp-color.png'),
                    link: '/wa-qr/data',
                    active: false,
                    sub_menu: [],
                  },
                  {
                    id: 89,
                    title: 'Log Activity',
                    icon: require('@/assets/icon/activity-log.png'),
                    icon_color: require('@/assets/icon/activity-log.png'),
                    link: '/audit-trail',
                    active: false,
                    sub_menu: [],
                  },
                  {
                    id: 101,
                    title: 'Hapus Data',
                    icon: require('@/assets/icon/delete-file.png'),
                    icon_color: require('@/assets/icon/delete-file.png'),
                    link: '/hapus-data',
                    active: false,
                    sub_menu: [
                      {
                        id: 102,
                        title: 'Data BPB',
                        link: '/hapus-data/bpb',
                        icon: require('@/assets/icon/delete-file.png'),
                        icon_color: require('@/assets/icon/delete-file.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 103,
                        title: 'Data Surat Jalan',
                        link: '/hapus-data/surat-jalan',
                        icon: require('@/assets/icon/delete-file.png'),
                        icon_color: require('@/assets/icon/delete-file.png'),
                        active: false,
                        sub_menu: [],
                      },
                    ],
                  },
                  {
                    id: 55,
                    title: 'Pengaturan',
                    icon: require('@/assets/icon/settings-2.png'),
                    icon_color: require('@/assets/icon/settings-color.png'),
                    link: '/master',
                    active: false,
                    sub_menu: [
                      {
                        id: 5,
                        title: 'Cabang',
                        icon: require('@/assets/icon/settings-2.png'),
                        icon_color: require('@/assets/icon/settings-color.png'),
                        link: '/cabang',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 47,
                        title: 'Vehicle',
                        icon: require('@/assets/icon/settings-2.png'),
                        icon_color: require('@/assets/icon/settings-color.png'),
                        link: '/vehicle/data',
                        active: false,
                        sub_menu: [],
                      },
                    {
                        id: 56,
                        title: 'Bank',
                        link: '/master/bank',
                        icon: require('@/assets/icon/settings-2.png'),
                        icon_color: require('@/assets/icon/settings-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 57,
                        title: 'Config',
                        link: '/master/config',
                        icon: require('@/assets/icon/settings-2.png'),
                        icon_color: require('@/assets/icon/settings-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                    ],
                  },

        ],
              menu_profile = {
                      id: 15,
                      title: 'Profile',
                      icon: require('@/assets/icon/userGrey.png'),
                      icon_color: require('@/assets/icon/userBlack.png'),
                      link: '/setting',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Profile',
                          link: '/setting?menu=profile',
                          active: false,
                          sub_menu: [],
                        },
                        {
                          title: 'Password',
                          link: '/setting?menu=password',
                          active: false,
                          sub_menu: [],
                        }
                      ],
                    }
              // if (menu_arr.length > 0) {
              //   menu_arr.push(menu_profile)
              // }

              // console.log(menu)
              
              TokenService.saveToken(
                res.results.token,
                JSON.stringify(user),
                JSON.stringify(menu_arr.length > 0 ? menu_arr : menu_default)
              )

              TokenService.saveReload(false)

              // Validasi redirect berdasarkan category_user_title
              const allowedCategories = ['Super User', 'General Manager']
              const userCategory = user.category_user_title

              if (!allowedCategories.includes(userCategory)) {
                // Selain Super User dan General Manager diarahkan ke setting profile
                window.location = `${process.env.BASE_URL}setting?menu=profile`
              } else if (menu_arr.length > 0) {
                window.location = `${process.env.BASE_URL}dashboard`
                // if (menu_arr[0].sub_menu.length > 0) {
                //   window.location = `${process.env.BASE_URL}/${menu_arr[0].sub_menu[0].link}`
                // } else {
                //   window.location = `${process.env.BASE_URL}/${menu_arr[0].link}`
                // }
              } else {
                  window.location = `${process.env.BASE_URL}dashboard`
              }

            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      }
    }
  }
</script>

<style scoped>
.label-input {
  font-size: 14px;
  font-weight: 500;
}
.border-radius {
  border-radius: 8px;
}
</style>